import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LanguageSyncService } from './shared/i18n/language-sync.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'digimax-fe';

  constructor() {
    inject(LanguageSyncService);
  }
}
